module.exports = __webpack_public_path__ + "img/lun.a23e24d6.svg";